import { LicensePlateTypeList, } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
const licensePlateTypeEnumUtils = createArrayUtils(LicensePlateTypeList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:licensePlateType',
});
export const licensePlateTypeUtils = {
    ...licensePlateTypeEnumUtils,
    createSelectableCardOptions: (t) => {
        const types = ['normal', 'interchangeable'];
        return types.map((licensePlateType) => ({
            ...licensePlateTypeEnumUtils.createOption(t, licensePlateType),
            image: `/images/vehicles/licensePlateType/${licensePlateType}.svg`,
        }));
    },
};
